class RBACController {
    constructor() {
        this.roles = {
            ADMIN: 'admin',
            EDITOR: 'editor',
            VIEWER: 'viewer'
        };
        this.currentUserRole = this.roles.EDITOR; // default
    }

    setRole(role) {
        if (Object.values(this.roles).includes(role)) {
            this.currentUserRole = role;
        }
    }

    getUserRole() {
        return this.currentUserRole;
    }

    hasPermission(action) {
        const permissions = {
            [this.roles.ADMIN]: ['*'],
            [this.roles.EDITOR]: ['read', 'write'],
            [this.roles.VIEWER]: ['read']
        };

        const userPerms = permissions[this.currentUserRole] || [];
        return userPerms.includes('*') || userPerms.includes(action);
    }
}

export const rbacController = new RBACController();
